/**
 * @fileoverview GET handler for the "/engagement/webhook_templates/territories" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementWebhookTemplatesTerritories } from "./constants";
import type { EngagementWebhookTemplatesTerritoriesResult } from "./types";

export const getEngagementWebhookTemplatesTerritories = reactQueryFetcherAdapter(
  engagementWebhookTemplatesTerritories,
  (signal: AbortSignal, appGroupId: string): Promise<EngagementWebhookTemplatesTerritoriesResult> => {
    return fetch("/engagement/webhook_templates/territories", "GET", { app_group_id: appGroupId }, { signal });
  }
);
